import {Form, Input, Spin} from 'antd';
import {FormInstance} from 'antd/lib/form';
import React, {useEffect, useState} from 'react';
import {apiFetchDialogChoices} from "../../../../containers/QueryBuilder/queryBuilderApi";
import {GenericTree} from "../../../../containers/QueryBuilder/types/GenericTree";
import TreeSelectWrapper from '../../../create/TreeSelectWrapper';
import { TreeNode } from 'antd/lib/tree-select';

interface Props {
    form: FormInstance
    endpoint: string
    dialogType: string
    fieldId: string
    fieldName: string
    showCheckedStrategy: 'SHOW_ALL' | 'SHOW_PARENT' | 'SHOW_CHILD'
}

const GenericTreeFilter = ({
                               form,
                               endpoint,
                               dialogType,
                               fieldId,
                               fieldName,
                               showCheckedStrategy
                           }: Props) => {

    const [value] = useState([]); //initial state of the tree i.e. empty
    const [dialogChoices, setDialogChoices] = useState<GenericTree[]>([]) //tree choices

    //backend api call to fetch choices for the dialog
    useEffect(() => {
        apiFetchDialogChoices(endpoint, dialogType).then(setDialogChoices)
    }, [endpoint, dialogType])

    const onChange = (codes: string[]) => {
        //add selected codes to the query
        form.setFieldValue(fieldId, codes)

        //find labels of the selected codes
        const labels = findLabelsForCodes(codes)

        //add labels to the query
        form.setFieldValue(`${fieldId}_labels`, labels)
    };

    const findLabelsForCodes = (codes: string[]) => {
        const labels: string[] = []
        const children = dialogChoices
            .map(category => category.children)
            .flatMap(child => child)

        codes.forEach(code => {
            children.forEach(child => {
                if (child === null) return;
                if (child.key === code.toString()) {
                    labels.push(child.title)
                }
            })
        })
        return labels
    }

    const getDialogChoicesAsTreeNode = (dialogChoices: GenericTree[]) => {
        return dialogChoices.map(dialogChoice => {

            let children: JSX.Element[] | undefined; 
            if (dialogChoice.children === null) {
                children = undefined
            } else if (dialogChoice.children.length === 0) {
                children = undefined;
            } else {
                children = getDialogChoicesAsTreeNode(dialogChoice.children); 
            }
            return <TreeNode 
                title={dialogChoice.title}
                value={dialogChoice.value || ""}
                key={dialogChoice.key}
                children={children}
            />
        })
    }

    //to avoid errors, wait until dialogChoices have been fetched to show dialog.
    //otherwise show a loading spinner
    if (dialogChoices && dialogChoices.length > 0) {
        return <>
            <Form.Item name={`${fieldId}_labels`} hidden={true} data-testid={'generic-tree-form'}>
                <Input/>
            </Form.Item>
            <Form.Item name={fieldId} data-testid={'generic-tree-container'}>
                <TreeSelectWrapper
                    value={value}
                    onChange={onChange}
                    treeCheckable={true}
                    showCheckedStrategy={showCheckedStrategy}
                    placeholder={`Select ${fieldName}`}
                    data-testid={'generic-tree-filter'}
                    treeNodeFilterProp={'title'}
                >
                    {getDialogChoicesAsTreeNode(dialogChoices)}
                </TreeSelectWrapper>
            </Form.Item>
        </>
    } else {
        return <Spin data-testid={'generic-tree-spinner'}/>
    }

}

export default GenericTreeFilter